import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import FilterSeparator from "components/DesignComponents/FilterSeparator";
import FilterButton from "components/Filters/components/FilterButton";
import FilterMenu from "components/Filters/components/FilterMenu";
import FilterDropdown from "components/Filters/FilterDropdown";
import { useFilters } from "components/Filters/hooks/useFilters";
import TableContext from "context/table/tableContext";
import { useMediaQueries } from "shared/hooks/useMediaQueries";

import {
    mediaMaxWidth599,
    mediaMaxWidth839,
    mediaMaxWidth839WithFlex,
    mediaMaxWidth899
} from "./styles";
import { DeviceDetailTwoFiltersProps } from "./types";

const DeviceDetailTwoFilters = ({
    firstFilter,
    secondFilter,
    firstFilterPlaceholder,
    secondFilterPlaceholder,
    customTableName,
    additionalParams
}: DeviceDetailTwoFiltersProps) => {
    const { hasNoPermissionToRead } = useContext(TableContext);

    const { t } = useTranslation();
    const { fromSm, toMd, to1099, fromLg } = useMediaQueries();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useFilters();

    const getCustomLoadingWidth = () => {
        if (toMd) {
            return 112;
        }

        return to1099 ? 24 : 112;
    };

    return (
        <div
            css={css({
                display: "flex",
                alignItems: "center",
                flex: "1",
                width: "100%"
            })}
        >
            <FilterDropdown
                filter={firstFilter}
                placeholder={t(`Filter##${firstFilterPlaceholder}`)}
                disabled={hasNoPermissionToRead}
                customTableName={customTableName}
                additionalParams={additionalParams}
                css={css([mediaMaxWidth899, mediaMaxWidth839])}
                containerCustomStyle={{
                    width: "unset",
                    ...mediaMaxWidth839,
                    ...mediaMaxWidth599
                }}
                containerLoaderCustomStyle={{
                    width: "246px",
                    ...mediaMaxWidth899,
                    ...mediaMaxWidth839WithFlex
                }}
            />

            {fromSm && <FilterSeparator width={1} height={36} />}

            {(fromSm && toMd) || fromLg ? (
                <FilterDropdown
                    filter={secondFilter}
                    placeholder={t(`Filter##${secondFilterPlaceholder}`)}
                    disabled={hasNoPermissionToRead}
                    customTableName={customTableName}
                    additionalParams={additionalParams}
                />
            ) : (
                <>
                    <FilterButton
                        onOpen={handleOpenMenu}
                        isDisabled={hasNoPermissionToRead}
                        customLoadingWidth={getCustomLoadingWidth()}
                        customMobileLoaderStyle={{
                            marginLeft: "24px"
                        }}
                    >
                        {t("Button##more filters")}
                    </FilterButton>

                    <FilterMenu
                        isOpen={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleCloseMenu}
                    >
                        <div>
                            <FilterDropdown
                                filter={secondFilter}
                                placeholder={t(
                                    `Filter##${secondFilterPlaceholder}`
                                )}
                                customTableName={customTableName}
                                additionalParams={additionalParams}
                            />
                        </div>
                    </FilterMenu>
                </>
            )}
        </div>
    );
};

export default DeviceDetailTwoFilters;
